module.exports = __webpack_public_path__ + "img/HelloNovel.4d148fe2.png";